export default {
  LIVE: 'live',
  GREEN: 'green',
  INFO: 'info',
  DANGER: 'danger',
  RED: 'red',
  SUCCESS: 'success',
  PRIMARY: 'primary',
  WARNING: 'warning',
  SECONDARY: 'secondary',
  NEW_VEHICLE_AVAILABLE: 'new-vehicle-available',
};
